import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import CheckAll from "src/images/Icons/newIcons/checkAll.svg";
import Delete from "src/images/Icons/newIcons/delete.svg";

import { hasLimitedAccess } from "../../helpers/getPermissions";
import {
	useGetInfiniteNotification,
	useGlobalActions,
} from "../../hooks/useNotifications";
import { IconButton } from "../Default/LekUI/Button";
import { Tooltip } from "../Default/LekUI/Tooltip";
import { ShortLimitedAccess } from "../NewComponents/LimitedAccess";
import { NotificationList } from "./NotificationsItems/List";

const GlobalActions = () => {
	// useGlobalActions jest w .jsx, więc react-query nie zna typu zmiennych
	const mutateAsync = useGlobalActions().mutateAsync as unknown as (variables: {
		action: "setAsResolved" | "remove";
	}) => Promise<unknown>;
	const { t } = useTranslation();

	return (
		<div className="flex-center-row">
			<Tooltip title={t("notifications.actions.setAllAsRead")}>
				<IconButton
					size="small"
					onClick={() => mutateAsync({ action: "setAsResolved" })}
				>
					<CheckAll className="icon-normal" />
				</IconButton>
			</Tooltip>
			<Tooltip title={t("notifications.actions.removeAll")}>
				<IconButton
					size="small"
					onClick={() => mutateAsync({ action: "remove" })}
				>
					<Delete className="icon-normal icon-black icon-width-normal" />
				</IconButton>
			</Tooltip>
		</div>
	);
};

const NotificationsContainer = () => {
	const { t } = useTranslation();
	const { data, hasNextPage, fetchNextPage } = useGetInfiniteNotification(
		!hasLimitedAccess(),
	);

	const renderEndOfMessage = () => {
		if (hasNextPage || hasNextPage === undefined) {
			return null;
		}

		if (data?.pages?.[0].length === 0) {
			return (
				<div
					className={cx(
						"flex items-center justify-center size-16 text-black",
						css`
              min-height: 100px;
            `,
					)}
				>
					{t("notifications.emptyState")}
				</div>
			);
		}

		return (
			<div
				className={cx(
					"flex items-center justify-center size-16 text-dark-grey py-16",
				)}
			>
				{t("infiniteScroll.endOfList")}
			</div>
		);
	};

	const renderContent = () => {
		if (hasLimitedAccess()) {
			return <ShortLimitedAccess />;
		}

		return (
			<InfiniteScroll
				dataLength={(data?.pages?.length || 0) * 10}
				next={fetchNextPage}
				hasMore={hasNextPage}
				scrollableTarget="scrollableDiv"
				loader={<div>{t("infiniteScroll.loading")}</div>}
				endMessage={renderEndOfMessage()}
			>
				<NotificationList notifications={data?.pages} />
			</InfiniteScroll>
		);
	};

	return (
		<div>
			<div className={cx("flex items-center justify-between p-12")}>
				<span className="size-18 text-black">{t("notifications.title")}</span>
				{!hasLimitedAccess() && <GlobalActions />}
			</div>
			{renderContent()}
		</div>
	);
};

export default NotificationsContainer;
